import { Badge, BadgeProps, CustomFlowbiteTheme } from 'flowbite-react'
import React, { FC, SVGProps } from 'react'

const customBadgeTheme: CustomFlowbiteTheme['badge'] = {
  icon: {
    on: 'rounded px-2 py-0.5',
  },
}

interface AppBadgeProps extends Omit<BadgeProps, 'icon'> {
  icon?: FC<Omit<SVGProps<SVGSVGElement>, 'ref'>>
}

const AppBadge: React.FC<AppBadgeProps> = ({ icon, children, ...props }) => (
  <Badge {...props} icon={icon} theme={customBadgeTheme}>
    {children}
  </Badge>
)
export default AppBadge
